<template>
    <el-dialog
        :title="title"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose"
        >
        <el-form >
          <el-form-item label="楼栋名称:" >
              <el-input  v-model="form.name"  autocomplete="off"></el-input>
        </el-form-item>
            <div class="buttom-box">
                    <el-button type="primary" @click="AddClick()" :loading="loading">提交</el-button>
                    <el-button size="small" @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
	import {
		AddBuilding,
        UpdateBuilding
	} from '@/assets/api/schoollog.js'
	import {
		findTeacherInfo,
	} from '@/assets/api/renyuan';
export default {
    components: {
    },
    props: ['detailsObj'],
    data() {

        return {
            dialogVisible: true,
            loading:false,
            title:'',
            form:{
                name:'',
            },
            cardid:"",
            schoolList:[],
            schoolInfo:{},
            title:''
          
        }

    },
    created(){
      this.Lookteacher() 
      console.log(this.detailsObj,'00000000000000000');

    if (JSON.stringify(this.detailsObj) != '{}') {
        this.title = '修改楼栋'
        this.form.name = this.detailsObj.name
    }else{
        this.title = '新增楼栋'
        
    }
      
    },
    mounted(){
            
    },
    methods:{
        
		Lookteacher() {
			let params = {
				userId: JSON.parse(localStorage.getItem('user')).id,
			}
			findTeacherInfo(params).then((res) => {
				console.log(res, '查看权限');
				this.schoolInfo = res.data.data
			}).catch((err) => {
				console.log(err);
			})
		},
        handleClose() {
            this.$emit('AddShowClick')
          },
        AddClick(){
        if (this.title == '新增楼栋') {
             this.deviceClick()
            
        }else if(this.title == '修改楼栋'){
            this.alterClick()
        }
        },
        alterClick(){
            const data = {
            name:this.form.name,
            id:this.detailsObj.id

          }
          UpdateBuilding(data).then((res)=> {
           this.$message({
                    type: 'success',
                    message: '修改成功'
                });
          this.loading = false
          this.handleClose()
        }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg||'接口异常',
                });
          })
        },
        deviceClick(){
          this.loading = true
          const data = {
            name:this.form.name,
            id:this.schoolInfo.schoolId

          }
          AddBuilding(data).then((res)=> {
           this.$message({
                    type: 'success',
                    message: '新增成功'
                });
          this.loading = false
          this.handleClose()
        }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg||'接口异常',
                });
          })
      }
    }
    }




</script>
<style  scoped lang="scss">
    /deep/ {

        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
            // margin-top: ;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 13%;
        // margin-top: 35px;

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>